<template>

  <div id="vue-search-app">
    <app-get-posts/>
    <app-navigation>
      <!-- Load the App Navigation Component-->
    </app-navigation>
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
      <!-- Load the router-view component provided by the vue-router plugin -->
    </router-view>
  </div><!-- #vue-search-app -->

</template>

<script>
import AppNavigation from './components/AppNavigation.vue';
import AppGetPosts from './components/AppGetPosts.vue';

export default {
	components: {
		'app-navigation': AppNavigation,
		'app-get-posts': AppGetPosts
	},
  mounted() {
    if (typeof __BUILD_VERSION__ !== 'undefined') console.info('BUILD VERSION: ' + __BUILD_VERSION__)
  }
};
</script>

<style>
.message {
    text-align: center;
    font-size: 30px;
}
</style>
